<template>
  <div>

    <v-row>
      <v-col cols="12" sm="3">
        <v-select
          label="Ano"
          :items="years"
          v-model="year"
          solo dense hide-details></v-select>
      </v-col>
      <v-col cols="12" sm="3">
        <v-select
          label="Mês"
          :items="months"
          v-model="month"
          item-text="name"
          item-value="id"
          solo dense hide-details></v-select>
      </v-col>
      <v-col cols="12" sm="2">
        <v-btn color="primary" @click="load()" block>
          <v-icon left>mdi-magnify</v-icon>Buscar
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="4">
        <v-card>
          <v-card-title>Instalações</v-card-title>
          <v-card-text class="text-h4 text--primary">
            {{ total }}
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card>
          <v-card-title>MRR instalado</v-card-title>
          <v-card-text class="text-h4 text--primary">
            R$ {{ total_price | formatMoney }}
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card>
          <v-card-title>Ticket médio</v-card-title>
          <v-card-text class="text-h4 text--primary">
            R$ {{ ticket_avg | formatMoney }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="data_plan">
      <v-col cols="12" md="4">
        <v-card>
          <v-card-title>Instalações por plano</v-card-title>
          <v-card-text>
            <bar-chart :chart-data="data_plan" :options="chart_options" :styles="chart_styles"/>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card>
          <v-card-title>Instalações por cidade</v-card-title>
          <v-card-text>
            <bar-chart v-if="data_city" :chart-data="data_city" :options="chart_options" :styles="chart_styles"/>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card>
          <v-card-title>Instalações por dia</v-card-title>
          <v-card-text>
            <v-calendar
              type="month"
              locale="pt-BR"
              color="primary"
              :value="calendar_start"
              :style="chart_styles">
              <template v-slot:day="{ date }">
                <div class="text-center" v-if="data_day[date]">
                  <v-chip x-small color="green accent-4" dark>{{ data_day[date] }}</v-chip>
                </div>
              </template>
            </v-calendar>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-alert v-if="loaded && total == 0" dense text type="info">
          Nenhuma instalação no período selecionado.
        </v-alert>
        <v-simple-table v-else>
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Usuário</th>
              <th>Plano</th>
              <th>Instalação</th>
              <th>Valor</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in current" :key="item.id">
              <td>{{ item.clientName }}</td>
              <td>{{ item.username }}</td>
              <td>{{ item.planName }}</td>
              <td>{{ item.setup | formatDate }}</td>
              <td>R$ {{ item.price | formatMoney }}</td>
              <td><v-btn icon :to="`/internet/${item.id}`"><v-icon>mdi-magnify</v-icon></v-btn></td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import api from '../../api/index.js';
import BarChart from '../../components/BarChart.js';

export default {
  components: { BarChart },
  data: () => ({
    current: [],
    years: [],
    year: null,
    month: null,
    loaded_year: null,
    loaded_month: null,
    months: [
      {id: 1, name: "Janeiro"},
      {id: 2, name: "Fevereiro"},
      {id: 3, name: "Março"},
      {id: 4, name: "Abril"},
      {id: 5, name: "Maio"},
      {id: 6, name: "Junho"},
      {id: 7, name: "Julho"},
      {id: 8, name: "Agosto"},
      {id: 9, name: "Setembro"},
      {id: 10, name: "Outubro"},
      {id: 11, name: "Novembro"},
      {id: 12, name: "Dezembro"}
    ],
    data_plan: null,
    data_city: null,
    loaded: false,
    dialog_loading: false,
    chart_options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: { display: false },
      scales: {
        yAxes: [{ ticks: { beginAtZero: true, precision: 0 } }]
      }
    },
    chart_styles: {
      position: "relative",
      height: "400px",
      width: "100%"
    }
  }),
  created: function() {
    var now = new Date();
    for(var y = now.getFullYear(); y >= now.getFullYear()-5; y--){
      this.years.push(y);
    }
    this.year = now.getFullYear();
    this.month = now.getMonth()+1;
    this.load();
  },
  computed: {
    total: function(){
      return this.current.length;
    },
    total_price: function(){
      return this.current.reduce(function(sum, item){
        return sum + Number(item.price || 0);
      }, 0);
    },
    ticket_avg: function(){
      if(this.current.length==0){
        return 0;
      }
      return this.total_price / this.current.length;
    },
    calendar_start: function(){
      var month = this.loaded_month < 10 ? "0" + this.loaded_month : this.loaded_month;
      return this.loaded_year + "-" + month + "-01";
    },
    data_day: function(){
      var days = {};
      this.current.forEach(function(item){
        if(!item.setup){
          return;
        }
        var date = String(item.setup).split("T")[0];
        days[date] = (days[date] || 0) + 1;
      });
      return days;
    }
  },
  methods: {
    load: function() {
      var me = this;
      me.current = [];
      me.data_plan = null;
      me.data_city = null;
      me.loaded = false;
      me.loaded_year = me.year;
      me.loaded_month = me.month;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api.get("/internet/instalacoes/"+me.year+"/"+me.month, {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.dialog_loading = false;
        me.loaded = true;
        me.current = response.data.sort(function(a, b){
          return String(a.setup || "").localeCompare(String(b.setup || ""));
        });
        me.data_plan = me.build("planName", "Sem plano");
        me.data_city = me.build("clientCity", "Sem cidade");
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao recuperar instalações!");
      });
    },
    build: function(field, fallback) {
      var groups = {};
      this.current.forEach(function(item){
        var name = String(item[field] || "").trim() || fallback;
        var key = name.toUpperCase();
        if(!groups[key]){
          groups[key] = {name: name, total: 0};
        }
        groups[key].total++;
      });
      var entries = Object.keys(groups).map(function(key){
        return groups[key];
      })
      .sort(function(a, b){
        return b.total - a.total;
      });
      if(entries.length==0){
        return null;
      }
      return {
        labels: entries.map(function(e){ return e.name; }),
        datasets: [{
          label: "Instalações",
          backgroundColor: "#4CAF50",
          data: entries.map(function(e){ return e.total; })
        }]
      };
    }
  }
};
</script>
